import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberToFixed'
})
export class NumberToFixedPipe implements PipeTransform {
    transform(value: string|number, precision: number = 2, forceFixed: boolean = false): any {

        if(!value) return value;

        value = Number(value);

        if((value % 1) || forceFixed){
            return value.toFixed(precision);
        }

        return value;
    }
}
